import { apiClient } from '@/api/client'
import type { DashboardResponse } from './types'

export async function fetchDashboard(): Promise<DashboardResponse> {
  const { data } = await apiClient.get<DashboardResponse>('/portal/admin/api/v2/dashboard')
  return data
}
